<ng-container ngPreserveWhitespaces>
  <display-symbol [security]="data.securityKey"></display-symbol> @if (altExchange) {
  <span class="alt-exchange">({{altExchange}})</span>
}
</ng-container>
